// Copyright (c) 2026 Or2 LLC. All rights reserved.
// Insight Platform - proprietary software by Nnaico (https://nnaico.com).
// See the LICENSE file in this repository. All rights reserved.

import ReactDOM from 'react-dom/client'
import { ThemeProvider, CssBaseline } from '@mui/material'
import CompanyAdmin from './components/CompanyAdmin'
import { buildTheme } from './theme'
import { useAppearance, applyDocumentThemeClasses } from './lib/appearance'
import './App.css'

// Apply dark/terminal classes and colors immediately to prevent flash
applyDocumentThemeClasses()

function CompanyAdminApp() {
  const { mode, style, scheme } = useAppearance()
  const isDarkMode = mode === 'dark'

  return (
    <ThemeProvider theme={buildTheme(mode, style, scheme)}>
      <CssBaseline />
      <CompanyAdmin isDarkMode={isDarkMode} />
    </ThemeProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(<CompanyAdminApp />)
